import { buildQueryContext, QueryFormData } from '@superset-ui/core';

export default function buildQuery(formData: QueryFormData) {
  const {
    categoryColumn = [], // Kolom yang akan ditampilkan
    series_columns = [], // Metrics
    adhoc_filters = [], // Optional filters
    temporal_column,
  } = formData;
  const queryContext = buildQueryContext(formData, baseQueryObject => {
    // console.log(formData, '@@@@@@@@@@');
    const filters = adhoc_filters?.map((filter: any) => ({
      col: filter.subject,
      op: filter.operator,
      val: filter.comparator,
    }));
    return [
      {
        ...baseQueryObject,
        columns: [formData.granularity_sqla, categoryColumn, ...series_columns], // Gabungkan groupColumn dan metrics sebagai columns
        metrics: [],
        orderby: [[formData.granularity_sqla, false]], // false untuk DESC
        row_limit: 10000,
        post_processing: [],
        is_timeseries: false,
        groupby: undefined, // Tidak ada grouping di SQL
        time_range: formData.time_range,
        time_grain_sqla: undefined, // Disable time grain
        granularity: formData.granularity_sqla, // Disable granularity
        filters: filters, // Gunakan format filter yang sudah dikonversi
      } as any,
    ];
  });
  return queryContext;
}
